import DataViewFrom from './DataViewForm.jsx';

export default DataViewFrom;
